"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFeeRecipientsIx = exports.overrideVaultEpochTimesIx = exports.removeQueuedWithdrawIx = exports.processWithdrawQueueIx = exports.withdrawVaultIx = exports.rolloverVaultIx = exports.collectCollateralIx = exports.burnOptionIx = exports.exerciseOptionIx = exports.acceptAuctionBidIx = exports.cancelAuctionIx = exports.initializeAuctionIx = exports.initializeOptionIx = exports.removeQueuedDepositIx = exports.processDepositQueueIx = exports.depositVaultIx = exports.initializeVaultIx = exports.fundVaultAuthorityIx = exports.updateVaultDepositLimitIx = exports.updateAdminIx = exports.initializeStateIx = void 0;
const vault_1 = require("./vault");
const flex_1 = require("./../flex/flex");
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const utils = __importStar(require("./utils"));
const flexUtils = __importStar(require("./../flex/flex-utils"));
async function initializeStateIx(managementFeePercentage, yieldFeePercentage, feeRecipients) {
    let [state, stateNonce] = utils.getStateAddress();
    let [vaultAuthority, vaultAuthorityNonce] = utils.getVaultAuthorityAddress();
    let args = {
        stateNonce,
        vaultAuthorityNonce,
        yieldFeePercentage,
        managementFeePercentage,
        feeRecipients,
    };
    return vault_1.vault.program.methods
        .initializeState(args)
        .accounts({
        state,
        admin: vault_1.vault.provider.wallet.publicKey,
        systemProgram: web3_js_1.SystemProgram.programId,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        vaultAuthority,
    })
        .instruction();
}
exports.initializeStateIx = initializeStateIx;
async function updateAdminIx(newAdmin, currentAdmin) {
    return vault_1.vault.program.methods
        .updateAdmin(newAdmin)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: currentAdmin ? currentAdmin : vault_1.vault.provider.wallet.publicKey,
    })
        .instruction();
}
exports.updateAdminIx = updateAdminIx;
async function updateVaultDepositLimitIx(vault, newDepositLimit) {
    return vault_1.vault.program.methods
        .updateVaultDepositLimit(newDepositLimit)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault,
    })
        .instruction();
}
exports.updateVaultDepositLimitIx = updateVaultDepositLimitIx;
async function fundVaultAuthorityIx(lamports) {
    return vault_1.vault.program.methods
        .fundVaultAuthority(new anchor.BN(lamports))
        .accounts({
        state: vault_1.vault.stateAddress,
        payer: vault_1.vault.provider.wallet.publicKey,
        vaultAuthority: vault_1.vault.vaultAuthority,
        systemProgram: web3_js_1.SystemProgram.programId,
    })
        .instruction();
}
exports.fundVaultAuthorityIx = fundVaultAuthorityIx;
async function initializeVaultIx(vaultName, underlyingMint, epochTimes, depositLimit) {
    let [vault, vaultNonce] = utils.getVaultAddress(vaultName);
    let [redeemableMint, redeemableMintNonce] = utils.getRedeemableMintAddress(vault);
    let [vaultUnderlyingTokenAccount, vaultUnderlyingTokenAccountNonce] = utils.getVaultUnderlyingTokenAccountAddress(vault);
    let [depositQueueHeader, depositQueueHeaderNonce] = utils.getDepositQueueHeaderAddress(vault);
    let [vaultDepositQueueUnderlyingTokenAccount, vaultDepositQueueUnderlyingTokenAccountNonce,] = utils.getVaultDepositQueueUnderlyingTokenAccountAddress(vault);
    let [withdrawQueueHeader, withdrawQueueHeaderNonce] = utils.getWithdrawQueueHeaderAddress(vault);
    let [vaultWithdrawQueueRedeemableTokenAccount, vaultWithdrawQueueRedeemableTokenAccountNonce,] = utils.getVaultWithdrawQueueRedeemableTokenAccountAddress(vault);
    console.log(epochTimes);
    let args = {
        vaultNonce,
        redeemableMintNonce,
        vaultUnderlyingTokenAccountNonce,
        depositQueueHeaderNonce,
        vaultDepositQueueUnderlyingTokenAccountNonce,
        withdrawQueueHeaderNonce,
        vaultWithdrawQueueRedeemableTokenAccountNonce,
        vaultName,
        startEpoch: epochTimes.startEpoch,
        endDeposits: epochTimes.endDeposits,
        startSettlement: epochTimes.startSettlement,
        endEpoch: epochTimes.endEpoch,
        epochCadence: epochTimes.epochCadence,
        depositLimit,
    };
    return vault_1.vault.program.methods
        .initializeVault(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        underlyingMint,
        redeemableMint,
        vaultUnderlyingTokenAccount,
        depositQueueHeader,
        vaultDepositQueueUnderlyingTokenAccount,
        withdrawQueueHeader,
        vaultWithdrawQueueRedeemableTokenAccount,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .instruction();
}
exports.initializeVaultIx = initializeVaultIx;
async function depositVaultIx(amount, vault, userKey, userUnderlyingTokenAccount, userRedeemableTokenAccount, underlyingMint, redeemableMint) {
    let vaultInfo = vault_1.vault.getVault(vault);
    let depositQueueHeaderInfo = await vault_1.vault.program.account.queueHeader.fetch(vaultInfo.vaultDepositQueueHeaderAddress);
    let [newUserQueueNode, newUserQueueNodeNonce] = utils.getDepositQueueNodeAddress(vaultInfo.vaultDepositQueueHeaderAddress, userKey, depositQueueHeaderInfo.seqNum);
    let remainingAccounts = [];
    if (depositQueueHeaderInfo.count.toNumber() != 0) {
        remainingAccounts.push({
            pubkey: depositQueueHeaderInfo.tail,
            isSigner: false,
            isWritable: true,
        });
    }
    let args = {
        underlyingAmount: amount,
        newDepositQueueNodeNonce: newUserQueueNodeNonce,
    };
    return vault_1.vault.program.methods
        .depositVault(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        userAuthority: userKey,
        userUnderlyingTokenAccount,
        userRedeemableTokenAccount,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        underlyingMint,
        redeemableMint,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        vaultDepositQueueUnderlyingTokenAccount: vaultInfo.vaultDepositQueueUnderlyingTokenAccount,
        depositQueueHeader: vaultInfo.vaultDepositQueueHeaderAddress,
        withdrawQueueHeader: vaultInfo.vaultWithdrawQueueHeaderAddress,
        newQueueNode: newUserQueueNode,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        systemProgram: anchor.web3.SystemProgram.programId,
        rent: anchor.web3.SYSVAR_RENT_PUBKEY,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.depositVaultIx = depositVaultIx;
async function processDepositQueueIx(vaultInfo, remainingAccounts) {
    return vault_1.vault.program.methods
        .processDepositQueue()
        .accounts({
        state: vault_1.vault.stateAddress,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        underlyingMint: vaultInfo.underlyingMint,
        redeemableMint: vaultInfo.redeemableMint,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        vaultDepositQueueUnderlyingTokenAccount: vaultInfo.vaultDepositQueueUnderlyingTokenAccount,
        depositQueueHeader: vaultInfo.vaultDepositQueueHeaderAddress,
        withdrawQueueHeader: vaultInfo.vaultWithdrawQueueHeaderAddress,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.processDepositQueueIx = processDepositQueueIx;
async function removeQueuedDepositIx(userKey, userUnderlyingTokenAccount, vaultInfo, queueNodeToRemove, remainingAccounts) {
    return vault_1.vault.program.methods
        .removeQueuedDeposit()
        .accounts({
        state: vault_1.vault.stateAddress,
        userAuthority: userKey,
        userUnderlyingTokenAccount,
        vault: vaultInfo.address,
        vaultDepositQueueUnderlyingTokenAccount: vaultInfo.vaultDepositQueueUnderlyingTokenAccount,
        depositQueueHeader: vaultInfo.vaultDepositQueueHeaderAddress,
        queueNodeToRemove,
        vaultAuthority: vault_1.vault.vaultAuthority,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.removeQueuedDepositIx = removeQueuedDepositIx;
async function initializeOptionIx(vault, strike) {
    let vaultInfo = vault_1.vault.getVault(vault);
    let underlyingInfo = flex_1.flex.getUnderlying(vaultInfo.underlyingMint);
    let [optionAccount, optionAccountNonce] = await flexUtils.getOptionAccountAddress(flex_1.flex.programId, underlyingInfo.address, new anchor.BN(underlyingInfo.count));
    let [flexVaultAddress, flexVaultNonce] = flexUtils.getVaultAddress(flex_1.flex.programId, optionAccount);
    let [optionMint, optionMintNonce] = flexUtils.getOptionMintAddress(flex_1.flex.programId, optionAccount);
    let [vaultOptionTokenAccount, vaultOptionTokenAccountNonce] = flexUtils.getUserOptionMintTokenAccountAddress(flex_1.flex.programId, optionMint, vault_1.vault.vaultAuthority);
    let args = {
        optionAccountNonce,
        optionMintNonce,
        vaultOptionTokenAccountNonce,
        flexVaultNonce,
        strike,
    };
    return vault_1.vault.program.methods
        .initializeOption(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        systemProgram: anchor.web3.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: anchor.web3.SYSVAR_RENT_PUBKEY,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            underlying: underlyingInfo.address,
            vault: flexVaultAddress,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
            collateralMint: underlyingInfo.mint,
            optionAccount,
            mintAuthority: flex_1.flex.mintAuthorityAddress,
            optionMint,
            vaultOptionTokenAccount,
        },
    })
        .instruction();
}
exports.initializeOptionIx = initializeOptionIx;
async function initializeAuctionIx(vault, auctionAmount, optionMint, bidEnd, cooldownEnd) {
    let [auctionAccount, auctionNonce] = await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from(anchor.utils.bytes.utf8.encode("auction")),
        optionMint.toBuffer(),
        vault_1.vault.vaultAuthority.toBuffer(),
        auctionAmount.toArrayLike(Buffer, "le", 8),
        bidEnd.toArrayLike(Buffer, "le", 8),
        cooldownEnd.toArrayLike(Buffer, "le", 8),
    ], flex_1.flex.programId);
    let [auctionVault, auctionVaultNonce] = await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from(anchor.utils.bytes.utf8.encode("auction-vault")),
        optionMint.toBuffer(),
        vault_1.vault.vaultAuthority.toBuffer(),
        auctionAmount.toArrayLike(Buffer, "le", 8),
        bidEnd.toArrayLike(Buffer, "le", 8),
        cooldownEnd.toArrayLike(Buffer, "le", 8),
    ], flex_1.flex.programId);
    let args = {
        auctionNonce,
        auctionVaultNonce,
        bidEnd,
        cooldownEnd,
    };
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .initializeAuction(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        systemProgram: anchor.web3.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: anchor.web3.SYSVAR_RENT_PUBKEY,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            auctionAccount,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
            auctionVault,
            auctionTokenMint: vaultInfo.option.optionMint,
            vaultOptionTokenAccount: vaultInfo.vaultOptionTokenAccount,
            bidCurrencyMint: vaultInfo.underlyingMint,
        },
    })
        .instruction();
}
exports.initializeAuctionIx = initializeAuctionIx;
async function cancelAuctionIx(vault, auction) {
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .cancelAuction()
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        systemProgram: anchor.web3.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: anchor.web3.SYSVAR_RENT_PUBKEY,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            auctionAccount: auction.address,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
            auctionVault: auction.auctionVault,
            auctionTokenMint: auction.auctionTokenMint,
            vaultOptionTokenAccount: vaultInfo.vaultOptionTokenAccount,
            bidCurrencyMint: vaultInfo.underlyingMint,
        },
    })
        .instruction();
}
exports.cancelAuctionIx = cancelAuctionIx;
async function acceptAuctionBidIx(vaultInfo, auction, bid, bidderAuctionTokenAccount) {
    return vault_1.vault.program.methods
        .acceptAuctionBid(new anchor.BN(bid.amount))
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            auctionAccount: auction.address,
            bidder: bid.bidder,
            bidAccount: bid.address,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
            bidVault: bid.bidVault,
            auctionVault: auction.auctionVault,
            bidderAuctionTokenAccount,
        },
    })
        .instruction();
}
exports.acceptAuctionBidIx = acceptAuctionBidIx;
async function exerciseOptionIx(vault) {
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .exerciseOption()
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            vault: vaultInfo.option.vault,
            collateralMint: vaultInfo.underlyingMint,
            optionAccount: vaultInfo.option.optionAccount,
            optionMint: vaultInfo.option.optionMint,
            vaultOptionTokenAccount: vaultInfo.vaultOptionTokenAccount,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        },
    })
        .instruction();
}
exports.exerciseOptionIx = exerciseOptionIx;
async function burnOptionIx(vault) {
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .burnOption()
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            vault: vaultInfo.option.vault,
            collateralMint: vaultInfo.underlyingMint,
            optionAccount: vaultInfo.option.optionAccount,
            mintAuthority: flex_1.flex.mintAuthorityAddress,
            optionMint: vaultInfo.option.optionMint,
            vaultOptionTokenAccount: vaultInfo.vaultOptionTokenAccount,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        },
    })
        .instruction();
}
exports.burnOptionIx = burnOptionIx;
async function collectCollateralIx(vault) {
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .collectCollateral()
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        flexAccounts: {
            program: flex_1.flex.programId,
            state: flex_1.flex.stateAddress,
            vault: vaultInfo.option.vault,
            optionAccount: vaultInfo.option.optionAccount,
            optionMint: vaultInfo.option.optionMint,
            vaultOptionTokenAccount: vaultInfo.vaultOptionTokenAccount,
            vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        },
    })
        .instruction();
}
exports.collectCollateralIx = collectCollateralIx;
async function rolloverVaultIx(vault, remainingAccounts) {
    let vaultInfo = vault_1.vault.getVault(vault);
    return vault_1.vault.program.methods
        .rolloverVault()
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.provider.wallet.publicKey,
        vault: vaultInfo.address,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        vaultAuthority: vault_1.vault.vaultAuthority,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.rolloverVaultIx = rolloverVaultIx;
async function withdrawVaultIx(userKey, amount, userUnderlyingTokenAccount, userRedeemableTokenAccount, vault) {
    let vaultInfo = vault_1.vault.getVault(vault);
    let withdrawQueueHeaderInfo = await vault_1.vault.program.account.queueHeader.fetch(vaultInfo.vaultWithdrawQueueHeaderAddress);
    let [newUserQueueNode, newUserQueueNodeNonce] = utils.getWithdrawQueueNodeAddress(vaultInfo.vaultWithdrawQueueHeaderAddress, userKey, withdrawQueueHeaderInfo.seqNum);
    let remainingAccounts = [];
    if (withdrawQueueHeaderInfo.count.toNumber() != 0) {
        remainingAccounts.push({
            pubkey: withdrawQueueHeaderInfo.tail,
            isSigner: false,
            isWritable: true,
        });
    }
    let args = {
        redeemableAmount: amount,
        newWithdrawQueueNodeNonce: newUserQueueNodeNonce,
    };
    return vault_1.vault.program.methods
        .withdrawVault(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        userAuthority: userKey,
        userUnderlyingTokenAccount,
        userRedeemableTokenAccount,
        vault,
        vaultAuthority: vault_1.vault.vaultAuthority,
        underlyingMint: vaultInfo.underlyingMint,
        redeemableMint: vaultInfo.redeemableMint,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        vaultWithdrawQueueRedeemableTokenAccount: vaultInfo.vaultWithdrawQueueRedeemableTokenAccount,
        withdrawQueueHeader: vaultInfo.vaultWithdrawQueueHeaderAddress,
        newQueueNode: newUserQueueNode,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        systemProgram: web3_js_1.SystemProgram.programId,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.withdrawVaultIx = withdrawVaultIx;
async function processWithdrawQueueIx(vaultInfo, remainingAccounts) {
    return vault_1.vault.program.methods
        .processWithdrawQueue()
        .accounts({
        state: vault_1.vault.stateAddress,
        vault: vaultInfo.address,
        vaultAuthority: vault_1.vault.vaultAuthority,
        underlyingMint: vaultInfo.underlyingMint,
        redeemableMint: vaultInfo.redeemableMint,
        vaultUnderlyingTokenAccount: vaultInfo.vaultUnderlyingTokenAccount,
        vaultWithdrawQueueRedeemableTokenAccount: vaultInfo.vaultWithdrawQueueRedeemableTokenAccount,
        withdrawQueueHeader: vaultInfo.vaultWithdrawQueueHeaderAddress,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.processWithdrawQueueIx = processWithdrawQueueIx;
async function removeQueuedWithdrawIx(userKey, userRedeemableTokenAccount, vaultInfo, queueNodeToRemove, remainingAccounts) {
    return vault_1.vault.program.methods
        .removeQueuedWithdraw()
        .accounts({
        state: vault_1.vault.stateAddress,
        userAuthority: userKey,
        userRedeemableTokenAccount,
        vault: vaultInfo.address,
        vaultWithdrawQueueRedeemableTokenAccount: vaultInfo.vaultWithdrawQueueRedeemableTokenAccount,
        withdrawQueueHeader: vaultInfo.vaultWithdrawQueueHeaderAddress,
        queueNodeToRemove,
        vaultAuthority: vault_1.vault.vaultAuthority,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.removeQueuedWithdrawIx = removeQueuedWithdrawIx;
async function overrideVaultEpochTimesIx(vault, args) {
    return vault_1.vault.program.methods
        .overrideVaultEpochTimes(args)
        .accounts({
        state: vault_1.vault.stateAddress,
        vault,
        admin: vault_1.vault.provider.wallet.publicKey,
    })
        .instruction();
}
exports.overrideVaultEpochTimesIx = overrideVaultEpochTimesIx;
async function updateFeeRecipientsIx(feeRecipients) {
    if (feeRecipients.length != 2) {
        throw Error("Expect 2 fee recipients");
    }
    return vault_1.vault.program.methods
        .updateFeeRecipients(feeRecipients)
        .accounts({
        state: vault_1.vault.stateAddress,
        admin: vault_1.vault.state.admin,
    })
        .instruction();
}
exports.updateFeeRecipientsIx = updateFeeRecipientsIx;
